import axios from "axios";

import { createAuthorizedClient, GOLDBOT_BASE_URL } from "./apiClient";

const positionsClient = createAuthorizedClient({
  baseURL: GOLDBOT_BASE_URL,
  timeout: 4500,
});

export const GoldBotPositionsErrorKind = Object.freeze({
  UNAVAILABLE: "unavailable",
  NETWORK: "network",
  INVALID_RESPONSE: "invalid_response",
  REQUEST: "request",
});

export class GoldBotPositionsApiError extends Error {
  constructor(message, kind, cause) {
    super(message);
    this.name = "GoldBotPositionsApiError";
    this.kind = kind;
    this.cause = cause;
  }
}

export function isPositionsRequestCanceled(error) {
  return axios.isCancel(error);
}

export async function getGoldBotPositions({ signal } = {}) {
  try {
    const response = await positionsClient.get("/positions", { signal });
    const payload = response.data;

    if (
      !payload ||
      typeof payload !== "object" ||
      Array.isArray(payload) ||
      !Array.isArray(payload.positions) ||
      typeof payload.stale !== "boolean" ||
      typeof payload.last_update !== "string"
    ) {
      throw new GoldBotPositionsApiError(
        "GoldBot returned an invalid positions response.",
        GoldBotPositionsErrorKind.INVALID_RESPONSE
      );
    }

    return payload;
  } catch (error) {
    if (
      isPositionsRequestCanceled(error) ||
      error instanceof GoldBotPositionsApiError
    ) {
      throw error;
    }

    if (error.response?.status === 503) {
      throw new GoldBotPositionsApiError(
        "GoldBot positions are unavailable.",
        GoldBotPositionsErrorKind.UNAVAILABLE,
        error
      );
    }

    if (!error.response) {
      throw new GoldBotPositionsApiError(
        "Could not reach the GoldBot positions API.",
        GoldBotPositionsErrorKind.NETWORK,
        error
      );
    }

    throw new GoldBotPositionsApiError(
      "GoldBot positions request failed.",
      GoldBotPositionsErrorKind.REQUEST,
      error
    );
  }
}
